<template>
  <div :class="classes">
    <div :class="$style['select-table-message']" v-loading="loading">
        <wt-paged-table  :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :class="$style['table-data-label']"
        ref="tablePage" :pager-count="maxPage" :isOutside="isOutside">
            <wt-table :list="list" :labels="tableLabels" :isSelect="isSelect" @select="select" :set-current-row="selectRow" ref="table" @select-all="selectAll">
                <template slot="before">
                    <slot name="before"/>
                </template>
                <slot/>
            </wt-table>
        </wt-paged-table>
        <!-- <div :class="$style['is-selected-list']">
            <div style="font-weight:600">已选择：</div>
            <div v-for="(item,index) in selectRow" :key="index" :class="$style['selected-table-list']">
                {{getFieldValue(item,showBeforParams)}}--{{getFieldValue(item,showName)}}
            </div>
        </div> -->

    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-select-list'

export default {
  name: 'pt-select-list',
  props: {
    // 页码显示的最大个数
    maxPage: {
      type: Number,
      default: 5
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedRows: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 5
    },
    totalCount: {
      type: Number,
      default: 0
    },
    // 需显示的字段名
    showName: {
      type: [Array, String],
      default: 'name'
    },
    // 显示在名字前的数据，如：label的type
    showBeforParams: {
      type: [Array, String],
      default: ''
    },
    // 唯一标标志字段名或字段路径
    keys: {
      type: [Array, String],
      default: 'id'
    },
    isSelect: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    selectList () {
      return this.$refs.table
    },
    table () {
      return this.selectList ? this.selectList.$refs.table : null
    },
    tablePage () {
      return this.$refs.tablePage
    }
  },
  data () {
    return {
      selectRow: this.selectedRows || [],
      totalNumber: this.totalCount,
      list: this.tableData
    }
  },
  watch: {
    totalCount (val) {
      this.totalNumber = val
    },
    selectRow: {
      handler: function (val) {
        this.$emit('selected', val)
      }
    },
    tableData: {
      handler: function (val) {
        this.list = val
      }
    },
    list () {
      this.$nextTick(_ => {
        if (this.selectRow) {
          this.selectRow.forEach(item => {
            this.list.forEach((etem, index) => {
              if (this.isEquile(item, etem)) {
                this.table && this.table.toggleRowSelection(this.list[index])
              }
            })
          })
        }
      })
    }
  },
  methods: {
    /*
     * keys 属性路径数组或字符串（如果只有一层的话）
     * eg:
     *    keys为数组：getFieldValue({a:{b:{c:'value1'}}},['a','b','c']) => value1
     *    or
     *    keys为字符串： getFieldValue({a:'value2'},'a')  => value2
     * 注：取值失败将返回null or undefined
     */
    getFieldValue (obj, keys) {
      /* global _ */
      if (_.isString(obj)) {
        return obj
      }
      if (_.isString(keys)) {
        return obj[keys]
      }
      let res = obj
      let keysClone = [...keys]
      while (_.isObject(res) && keysClone.length) {
        let currentKey = keysClone.splice(0, 1)
        res = res[currentKey]
      }
      return res
    },
    // 根据唯一标志，判定是否是同一条数据
    isEquile (item, etem) {
      let key = this.getFieldValue(etem, this.keys)
      let rowKey = typeof item === 'string' ? item : this.getFieldValue(item, this.keys)
      return key === rowKey
    },
    // resetPage () {
    //   this.tablePage.resetPage()
    // },
    reset () {
      this.tablePage.resetPage()
    //   this.selectRow = []
    },
    showReTry () {
      this.tablePage.showReTry()
    },
    selectAll (val) {
      if (val && val.length > 0) {
        // 全部选中
        val.forEach(etem => {
          let flag = this.selectRow.find((item, index) => {
            return this.isEquile(item, etem)
          })
          if (!flag) {
            this.selectRow.push(etem)
          }
        })
      } else {
        // 全部取消
        // 当前页 全部取消选中
        this.list.forEach(tableRow => {
          let index = this.selectRow.findIndex(row => this.isEquile(tableRow, row))
          if (index > -1) {
            this.selectRow.splice(index, 1)
          }
        })
      }
    },
    select (selection, val) {
      // 选中或者取消选中单条数据
      let index = this.selectRow.findIndex(item => {
        return this.isEquile(item, val)
      })
      index > -1 ? this.selectRow.splice(index, 1) : this.selectRow.push(val)
    },
    getTableData (page, next) {
      // 这里加延时，是为了给勾选状态以(动画)过渡时间
      this.$emit('getTableData', page, data => {
        this.list = data
        setTimeout(() => {
          next(data)
        }, 200)
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

.table-data-label{
    width: 100%;
}
.select-table-message{
    display: flex
}
.is-selected-list{
    padding: 20px
}
.selected-table-list{
    padding-top: 10px;
}
</style>
